import { cloneDeep, get, isArray, isEmpty, isNil, sortBy, trim } from 'lodash';

import { truncateArrayAttribute } from 'components/customer/external_app_card/lib/truncate_array_attribute';

export function applyArrayLimits(sourceData, limits) {
  if (isNil(sourceData) || (isArray(limits) && isEmpty(limits))) return sourceData;
  if (!isArray(limits)) {
    throw Error('applyArrayLimits: invalid arguments');
  }

  let workingData = cloneDeep(sourceData);
  const sortedLimits = sortBy(limits, ['field']);
  sortedLimits.forEach(limitExpr => {
    const path = trim(get(limitExpr, 'field'));
    const limit = get(limitExpr, 'maxItems');
    if (!path || !limit) {
      throw Error(`applyArrayLimits: invalid limit expression "${JSON.stringify(limitExpr)}"`);
    }

    const maxItems = Number.parseInt(limit);
    if (Number.isNaN(maxItems) || maxItems < 1) {
      throw Error(`applyArrayLimits: invalid limit for path "${path}". Expected positive number, got ${limit}`);
    }

    workingData = truncateArrayAttribute(workingData, path, maxItems);
  });

  return workingData;
}
